/**
 * Get a suitable value.
 * @param {obj[]} platforms - Array of platforms to get an appropriate name from.
 * @returns {String} - A platforms name
 */
export function getPlatformName(platforms) {
  // Extract nicenames directly when needed
  const getNicename = (p) => p?.platform?.nicename || p?.nicename

  if (!platforms || platforms.length === 0) {
    console.warn('No platforms passed in')
    return ''
  }

  // Check if all platforms have valid nicenames
  const allHaveNicenames = platforms.every((p) => Boolean(getNicename(p)))
  if (!allHaveNicenames) {
    console.warn('Some platforms are missing nicenames')
    return ''
  }

  // Check for PlayStation (PS5 and PS4 combination) or Xbox combination
  if (platforms.length === 2) {
    const names = platforms.map(getNicename).sort()

    // PlayStation check
    if (names[0] === 'PS4' && names[1] === 'PS5') {
      return 'PlayStation'
    }

    // Xbox check
    if (names[0] === 'Xbox One' && names[1] === 'Xbox Series X/S') {
      return 'Xbox'
    }
  }

  // Check for multi-platform
  if (platforms.length > 1) {
    return 'Multi-Platform'
  }

  // Return single platform name or N/A
  return getNicename(platforms[0]) || 'N/A'
}
